
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AverageMassInput extends Vue {
  @Model("input", { type: String }) readonly value!: string;
  @Prop({ type: Boolean, default: false }) readonly useAverageMass!: boolean;
  @Prop({ type: String, default: "outlined" }) readonly actionVariant!: "text" | "outlined";
  @Prop({ type: String, default: "primary" }) readonly saveColor!: string;
  @Prop({ type: String, default: "treatments" }) readonly infoSubject!: string;
  @Prop({ type: Boolean, default: false }) readonly isLocked!: boolean;

  dialog: boolean = false;
  draft: string = "";
  localUseAverageMass: boolean = false;

  get isNumber(): boolean {
    const value = Number(this.value);
    return Number.isFinite(value);
  }

  get isPositive(): boolean {
    const value = Number(this.value);
    return value > 0;
  }

  get isDraftNumber(): boolean {
    const value = Number(this.draft);
    return Number.isFinite(value);
  }

  get isDraftPositive(): boolean {
    const value = Number(this.draft);
    return value > 0;
  }

  created() {
    this.localUseAverageMass = this.useAverageMass;
  }

  @Watch("useAverageMass")
  onUseAverageMassPropChange(val: boolean) {
    this.localUseAverageMass = val;
  }

  emitUseAverageMass() {
    if (this.isLocked) {
      return;
    }

    this.$emit("update:useAverageMass", this.localUseAverageMass);
  }

  openDialog() {
    if (this.isLocked) return;
    if (!this.localUseAverageMass) return;
    this.draft = this.value || "";
    this.dialog = true;
    this.$nextTick(() => requestAnimationFrame(() => (this.$refs.averageMassInput as any)?.focus()));
  }

  openInfoDialog() {
    this.$store.commit("popup/displayOk", {
      title: "Average Mass",
      bullets: [`Using average mass will show ${this.infoSubject} with doses that are mass dependent.`, "Enter the average mass per animal like 250kg"],
    });
  }

  closeDialog() {
    this.dialog = false;
  }

  save() {
    this.$emit("input", this.draft);
    this.closeDialog();
  }
}
